export default __webpack_public_path__ + "static/media/about2.d750b044.png";